<template>
  <section id="header">
    <nav :class="menuOpen ? 'mobile-nav' : ''">
      <!-- Logo -->
      <a href="/" class="logo" :class="menuOpen ? 'mobile-logo' : ''">
        <img
          src="../assets/zingal-logo.png"
          alt="Zingal Son Kuşak"
          width="150"
          class="logo-img"
        />
      </a>
      <!-- Menu item  -->
      <ul :class="menuOpen ? 'mobile-nav-ul' : ''" @click="menu()">
        <li>
          <anchor-router-link
             :to="{hash : item.hash}"
            v-for="(item, i) in menuItem"
            :key="i"
            :scrollOptions="{
              duration: 300,
              offset: 0,
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false,
              x: false,
              y: true,
            }"
            >{{item.name}}</anchor-router-link
          >
        </li>
        <li>
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="customSwitch1"
              @change="langChanged($event)"
              :checked="!check"
            />
            <label class="custom-control-label" for="customSwitch1">
              <img :src="require('@/assets/' + langImg)" width="24" alt="" />
            </label>
          </div>
        </li>
      </ul>
      <!-- Mobil button -->
      <div class="mobile-btn" :class="menuOpen ? 'open' : ''" @click="menu()">
        <div class="mobile-btn-burger"></div>
      </div>
    </nav>
   
  </section>
</template>

<script>
import AnchorRouterLink from "vue-anchor-router-link";
import i18n from "@/plugins/i18n.js";

export default {
  data() {
    return {
      languages: Object.values(i18n.messages),
      menuOpen: false,
      menuItem: [],
      check: false,
      langImg: "",
    };
  },
  methods: {
    menu() {
      this.menuOpen = !this.menuOpen;
    },
    langChanged(value) {
      if (value.target.checked) {
        localStorage.setItem("lang", "tr");
        location.reload();
      } else {
        localStorage.setItem("lang", "en");
        location.reload();
      }
    },
  },
  components: {
    AnchorRouterLink,
  },
  mounted(){
      window.addEventListener("scroll", function () {
      var nav = document.querySelector("nav");
      nav.classList.toggle("sticky", window.scrollY > 0);
    });
  },
  created() {
    if (localStorage.getItem("lang") === "en") {
      this.check = true;
      this.langImg = "uk.svg";
      this.menuItem = this.$i18n.messages.en.menus;
    } else if (localStorage.getItem("lang") === "tr") {
      this.check = false;
      this.langImg = "turkey.svg";
      this.menuItem = this.$i18n.messages.tr.menus;
    }
  }
};
</script>

<style scoped>
.custom-control-input:focus ~ .custom-control-label::before {
  border-color: #3f3f3f !important;
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0) !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #3f3f3f !important;
  background-color: #3f3f3f !important;
}
label {
  color: #aeaeaf;
}
label img {
  margin: 0;
}
ul a {
  color: #aeaeaf;
  text-decoration: none;
  margin-right: 10px;
  transition: all 0.5s ease-in-out;
}
ul a:hover {
  color: #fff;
}
ul img {
  margin-right: 10px;
}
nav {
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.5s;
  padding: 40px 100px;
  font-family: "Cabin", sans-serif;
  background-color: #333;
}

.logo-img {
  position: absolute;
  top: 30px;
  left: 100px;
  z-index: 99;
}

nav ul {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
nav ul li {
  position: relative;
  list-style: none;
}
nav ul li a {
  position: relative;
  margin: 0 15px;
  text-decoration: none;
  color: #aeaeaf;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 1.2em;
  transition: 0.6s;
}
nav ul li a:hover {
  color: #fff;
}
nav.sticky {
  position: fixed;
  padding: 35px 100px;
  background-color: rgb(0, 0, 0, 0.4);
  z-index: 99;
}
nav.sticky ul li a {
  color: #fff;
}
nav.sticky .logo {
  color: #fff;
}

/*Mobile Menu Buton */
.mobile-btn {
  display: none;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  color: #fff;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  z-index: 999;
}
.mobile-btn:hover {
  border-color: #fff;
}
.mobile-btn-burger {
  z-index: 999;
  width: 25px;
  height: 3px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(255, 101, 47, 0.2);
  transition: all 0.5s ease-in-out;
}
.mobile-btn-burger::before,
.mobile-btn-burger::after {
  content: "";
  position: absolute;
  width: 25px;
  height: 3px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(255, 101, 47, 0.2);
  transition: all 0.5s ease-in-out;
}

.mobile-btn-burger::before {
  transform: translateY(-7px);
}
.mobile-btn-burger::after {
  transform: translateY(7px);
}

.mobile-btn.open .mobile-btn-burger {
  transform: translateX(-50px);
  background: transparent;
  box-shadow: none;
}
.mobile-btn.open .mobile-btn-burger::after {
  transform: rotate(45deg) translate(35px, -35px);
}
.mobile-btn.open .mobile-btn-burger::before {
  transform: rotate(-45deg) translate(35px, 35px);
}

/* Mobil Logo Responsive*/
@media screen and (max-width: 400px) {
  .logo-img {
    top: 25px;
    left: 30px;
  }
}

/* Mobile Responsive */
@media screen and (max-width: 1125px) {
  nav ul {
    display: none;
  }

  .mobile-btn {
    display: flex;
    position: fixed;
    top: 40px;
    right: 40px;
  }
  nav {
    height: 0;
    transition: all 0.5s ease-in-out;
  }
  nav.mobile-nav {
    position: fixed;
    width: 100%;
    height: 100vh;
    z-index: 999;
    left: 0;
    top: 0;
    background: rgb(0, 0, 0, 0.9);
    flex-direction: column;
    transition: all 0.5s ease-in-out;
    padding: 15vh 0px;
  }

  nav ul.mobile-nav-ul {
    display: block;
    text-align: center;
    padding: 0;
  }
  nav ul.mobile-nav-ul li a {
    display: block;
    padding: 20px 0;
  }
  .logo.mobile-logo {
    display: none;
  }
  nav.sticky {
    padding: 60px 100px;
  }
}
</style>
